import React from "react";
import {
  MDBCard,
  MDBCardBody,
  MDBContainer,
  MDBDataTable,
  MDBBtn,
  MDBCol,
  MDBRow,
} from "mdbreact";

const SellerLocationView = (props) => {
  return (
    <MDBContainer style={{ minWidth: "1000px",paddingTop:'50px' }}>
      <MDBCard>
        <MDBRow>
          <MDBCol>
            <MDBBtn color='deep-purple' onClick={() => props.addModal("ADD")}>Tambah Alamat</MDBBtn>
          </MDBCol>
          <MDBCol />
        </MDBRow>
        <MDBCardBody>
          <MDBDataTable
            hover
            noBottomColumns
            responsive
            data={props.data}
          />
        </MDBCardBody>
      </MDBCard>
    </MDBContainer>
  );
};

export default SellerLocationView;
